// P&L category exclusions.
//
// Categories that should never land in a P&L report (tax, tips, gift card
// activity…) can be explicitly excluded instead of being left unmapped. The
// exclusions are stored per store in stores.inventory_period_config under
// `pnl_category_exclusions`, alongside the other P&L setup state:
//
//   {
//     inventory: { [inventoryCategoryName]: reason },
//     clover:    { ["menu_category:ID" | "revenue_class:ID"]: reason },
//   }
//
// A category counts as "resolved" for the mapping-completeness check when it
// is either mapped to a P&L category or excluded with a reason.

import supabase from '../config/supabase';

export const EXCLUSION_REASONS = [
  { value: 'excluded', label: 'Exclude from report' },
  { value: 'non_revenue', label: 'Non-revenue' },
  { value: 'tax', label: 'Tax' },
  { value: 'tips', label: 'Tips' },
  { value: 'service_charge', label: 'Service charge' },
  { value: 'gift_card', label: 'Gift card activity' },
  { value: 'other', label: 'Other excluded category' },
];

export const exclusionLabel = (value) =>
  EXCLUSION_REASONS.find((r) => r.value === value)?.label || 'Excluded';

export const cloverExclusionKey = (categoryType, cloverCategoryId) =>
  `${categoryType}:${cloverCategoryId}`;

export async function loadCategoryExclusions(storeId) {
  const { data } = await supabase
    .from('stores')
    .select('inventory_period_config')
    .eq('id', storeId)
    .maybeSingle();
  const ex = data?.inventory_period_config?.pnl_category_exclusions || {};
  return {
    inventory: ex.inventory || {},
    clover: ex.clover || {},
  };
}

export async function saveCategoryExclusions(storeId, exclusions) {
  const { data } = await supabase
    .from('stores')
    .select('inventory_period_config')
    .eq('id', storeId)
    .maybeSingle();
  const cfg = data?.inventory_period_config || {};
  const next = {
    ...cfg,
    pnl_category_exclusions: {
      inventory: exclusions.inventory || {},
      clover: exclusions.clover || {},
    },
  };
  const { error } = await supabase
    .from('stores')
    .update({ inventory_period_config: next })
    .eq('id', storeId);
  if (error) throw error;
  return next.pnl_category_exclusions;
}
